// extracted by mini-css-extract-plugin
export var breadcrumb = "cerez-politikasi-module--breadcrumb--ictf2";
export var holder = "cerez-politikasi-module--holder--shvco";